import React, { useState } from "react";
import authBg from "../../images/authBg.jpg";
import fmeLogo from "../../images/fmeLogo.png";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { resources_EN } from "../componentUtils";
import { Path } from "../../RoutesUtils";
import { PostService } from "../../services/genericPostService";
const ResetPassword = () => {
  const [password, setPassword] = useState({
    newPass: "",
    confirmPass: "",
  });
  const param = useParams();
  const navigate = useNavigate();
  console.log("Params", param);
  const onChange = (event) => {
    const { name, value } = event.target;
    setPassword({
      [name]: value,
    });
  };

  const changePass = () => {
    const validate = validation();
    if (validate) {
      const data = {
        user_id: param.query,
        new_password: password.newPass,
        confirm_password: password.confirmPass,
      };
      const url = "/fmeApi/changePassword.php";
      PostService(url, data, modal);
    }
  };

  const validation = () => {
    if (password.newPass.length < 1) {
      modal("error", "Error", "Indtast venligst din nye adgangskode");
      return false;
    }
    if (password.confirmPass.length < 1) {
      modal("error", "Error", "Indtast venligst din bekræftelsesadgangskode");
      return false;
    }
    if (password.newPass !== password.confirmPass) {
      modal(
        "error",
        "Error",
        "Din nye adgangskode og bekræft adgangskode stemmer ikke overens"
      );
      return false;
    }
    return true;
  };

  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((response) => {
      if (response.isConfirmed && icon === resources_EN.success) {
        navigate(Path.login);
      }
    });
  };

  return (
    <div className="2xl:h-screen lg:h-[130vh] flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 lg:block hidden">
        <img
          src={authBg}
          alt="Decorative flower"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="w-full lg:w-1/2 p-8 lg:p-12 lg:p-16 flex flex-col justify-center items-center">
        <div className="w-full max-w-md">
          <div className="flex justify-center">
            <img src={fmeLogo} alt="Forglem mig ej logo" className="2xl:w-auto lg:w-44 w-auto" />
          </div>

          <h1 className="text-2xl lg:text-3xl text-center text-green 2xl:my-16 my-12">
            Nulstil din adgangskode
          </h1>

          <form>
            <div className="flex flex-col gap-8">
              <div className="w-full">
                <label htmlFor="password" className="block text-sm font-medium">
                  Adgangskode
                </label>
                <input
                  id="password"
                  name="newPass"
                  type="password"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="****************"
                  onChange={onChange}
                  value={password.newPass}
                />
              </div>
              <div className="w-full">
                <label htmlFor="password" className="block text-sm font-medium">
                  Bekræft adgangskode
                </label>
                <input
                  id="password"
                  name="confirmPass"
                  type="password"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="****************"
                  onChange={onChange}
                  value={password.confirmPass}
                />
              </div>
            </div>

            <div className="flex justify-center md:mt-12 mt-8 mb-8">
              <button
                type="button"
                className="py-3 px-20 border border-transparent rounded-full text-sm font-medium text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
                onClick={changePass}
              >
                Opret en konto
              </button>
            </div>

            <div className="text-center">
              <p className="text-md">
                Har du allerede en konto?
                <a href={Path.login} className="ml-1 font-bold border-b">
                  Log ind
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
